<template>
    <div class="column_center_start w-full">
        <div class="column_start_start w-full my-4">
            <text class="title">{{ orderSpec.frontEndDisplayName }}</text>
            <div class="row_center_start w-full">
                <text class="subTitle mr-3" v-if="orderSpec.mustHave">必選</text>
                <text class="subTitle" v-if="!orderSpec.isSingleSelection">複選[最少{{
                    orderSpec.multiSelectionMin }}, 最多{{ orderSpec.multiSelectionMax }}]{{
                        orderSpec.allowSelectManyTimes ? '(可重複選)' : '' }}</text>
            </div>
        </div>
        <div class="column_center_center w-full" v-if="!orderSpec.allowSelectManyTimes">
            <!-- 單選 / 複選欄位 -->
            <productDetailSingleSubOption class="column_start_start option"
                :class="{ active: isSelected(subSpecIndex) }"
                v-for="(subSpec, subSpecIndex) in orderSpec.productSpec.specOptions" :key="subSpecIndex"
                :product="subSpec"
                @click="orderSpec.multiSelectionMax === 1 || orderSpec.isSingleSelection ? selectedSingleItem(subSpecIndex) : selectedMultipleItems(subSpecIndex)" />

        </div>

        <div class="column_center_start w-full" v-if="orderSpec.allowSelectManyTimes">
            <!-- 可重複選欄位 -->
            <productDetailMultiSubOption class="column_center_start option"
                :class="{ active: isSelected(subSpecIndex) }"
                v-for="(subSpec, subSpecIndex) in orderSpec.productSpec.specOptions" :key="subSpecIndex"
                :product="subSpec" @addQuantity="addOptionQuantity(subSpecIndex)"
                @subtractQuantity="subtractOptionQuantity(subSpecIndex)"
                :quantity="checkOptionQuantity(subSpecIndex)" />
        </div>
    </div>
</template>
<script>
import productDetailSingleSubOption from "@/components/store/productDetailSingleSubOption.vue";
import productDetailMultiSubOption from "@/components/store/productDetailMultiSubOption.vue";
import commonUtilities from "@/utils/common.utils";
export default {
    props: {
        orderSpec: {
            type: Object,
            default: () => { }
        },
    },
    components: {
        productDetailSingleSubOption,
        productDetailMultiSubOption
    },
    computed: {
        orderSpecs() {
            return this.$store.state.order.orderSpecs
        }
    },
    data() {
        return {
            orderSpec1: {}
        }
    },
    created() {
        this.orderSpec1 = this.orderSpec
    },
    methods: {
        selectedSingleItem(subSpecIndex) {
            // 單選
            const hasSelected = this.orderSpec1.subSpecOptionSelectCount[subSpecIndex] > 0

            if (!hasSelected) {
                // 將選到的 subSpecOptionSelectCount[subSpecIndex] 設為 1，其餘設為0
                this.orderSpec1.subSpecOptionSelectCount = this.orderSpec1.subSpecOptionSelectCount.map((el, i) => {
                    return i === subSpecIndex ? 1 : 0
                })
            } else {
                this.orderSpec1.subSpecOptionSelectCount[subSpecIndex] = 0
            }
            this.updateOrderSpec()
        },
        selectedMultipleItems(subSpecIndex) {
            // 複選
            // 檢查選項是否已經被選中
            const hasSelected = this.orderSpec1.subSpecOptionSelectCount[subSpecIndex] > 0
            const totalCount = this.orderSpec1.subSpecOptionSelectCount.reduce((acc, el) => acc + el, 0)

            if (!hasSelected) {
                // 檢查是否超過最大選擇數
                if (totalCount >= this.orderSpec1.multiSelectionMax) {
                    commonUtilities.createToast("warning", `最多選擇${this.orderSpec1.multiSelectionMax}個`, "")
                    return
                }
                // 如果沒有被選中，則添加到選中的選項中
                this.orderSpec1.subSpecOptionSelectCount[subSpecIndex]++
            } else {
                // 如果已經被選中，則從選中的選項中移除
                this.orderSpec1.subSpecOptionSelectCount[subSpecIndex]--
            }
            this.updateOrderSpec()
        },
        addOptionQuantity(subSpecIndex) {
            // 複選 ＆ 可重複選則加點數量
            // 檢查是否超過最大選擇數
            const currentSpecSelectCount = this.orderSpec1.subSpecOptionSelectCount.reduce((acc, el) => acc + el, 0)
            const currentSpecSelectionMax = this.orderSpec1.multiSelectionMax
            if (currentSpecSelectCount >= currentSpecSelectionMax) {
                commonUtilities.createToast("warning", `最多選擇${currentSpecSelectionMax}個`, "")
                return
            }
            this.orderSpec1.subSpecOptionSelectCount[subSpecIndex]++
            this.updateOrderSpec()
        },
        subtractOptionQuantity(subSpecIndex) {
            const currentSpecSelectCount = this.orderSpec1.subSpecOptionSelectCount.reduce((acc, el) => acc + el, 0)
            // 如果加點數量為 0 或是該選項沒有被選中，則不做任何事
            if (currentSpecSelectCount === 0 || this.orderSpec1.subSpecOptionSelectCount[subSpecIndex] === 0) {
                return
            }
            // 如果加點數量為1，則移除選項
            if (currentSpecSelectCount == 1) {
                this.orderSpec1.subSpecOptionSelectCount[subSpecIndex]--
                this.updateOrderSpec()
                return
            }
            // 如果加點數量大於1，則數量減一，並移除其中一個選項
            if (currentSpecSelectCount > 1) {
                this.orderSpec1.subSpecOptionSelectCount[subSpecIndex]--
            }
            this.updateOrderSpec()
        },
        checkOptionQuantity(subSpecIndex) {
            return this.orderSpec1.subSpecOptionSelectCount[subSpecIndex]
        },
        isSelected(subSpecIndex) {
            return this.orderSpec1.subSpecOptionSelectCount[subSpecIndex] > 0
        },
        updateOrderSpec() {
            const orderSpecs = this.orderSpecs.map((el) => {
                if (el.id === this.orderSpec1.id) {
                    return this.orderSpec1
                }
                return el
            })
            this.$store.commit("order/setOrderSpecs", orderSpecs)
        }
    }
}
</script>
<style lang="scss" scoped>
.subTitle {
    font-size: 14px;
    font-weight: 400;
    font-family: PingFang SC;
    color: #d60c0a;
}

.option {
    width: 100%;
    padding: 10px 4%;
    background-color: #eeeeee;
    font-size: 16px;
    font-weight: 400;
    font-family: PingFang SC;
    margin-bottom: 10px;
    border-radius: 6px;

    img {
        width: 32px;
        height: 32px;
    }
}

.option.active {
    border: #FD4F02 2px solid;
    background-color: #fff;
    color: #FD4F02;
}
</style>